import { Heart } from 'lucide-react'
import { platformIcons, platformNames } from '../data/config'
import { getTheme } from '../utils/colors'

function Footer({ config, isLight = false }) {
  const theme = getTheme(isLight, config.profile?.fontColor)
  const profile = config.profile
  const social = config.social

  const currentYear = new Date().getFullYear()

  const footerLinks = {
    navigation: [
      { name: '首页', href: '#home' },
      { name: '作品', href: '#works' },
      { name: '合作', href: '#collaboration' },
      { name: '关于', href: '#about' },
      { name: '联系', href: '#contact' }
    ],
    platforms: [
      { name: '抖音', href: social?.douyin || '#' },
      { name: '小红书', href: social?.xiaohongshu || '#' },
      { name: 'B站', href: social?.bilibili || '#' },
      { name: '快手', href: social?.kuaishou || '#' },
      { name: '西瓜视频', href: social?.xigua || '#' }
    ],
    cooperation: [
      { name: '产品测评', href: '#collaboration' },
      { name: '探店打卡', href: '#collaboration' },
      { name: '品牌植入', href: '#collaboration' },
      { name: '直播带货', href: '#collaboration' }
    ]
  }

  return (
    <footer className={`border-t ${theme.footerBorder}`} style={{ backgroundColor: config.profile?.sectionBackground || '#000000' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* 品牌信息 */}
          <div className="lg:col-span-1">
            <h3 className={`text-xl font-bold mb-4 ${theme.text}`}>{profile?.name || '创作者'}</h3>
            <p className={`text-sm mb-4 ${theme.textSecondary}`}>
              {profile?.tagline || '多平台内容创作者'}
            </p>
            <p className={`text-sm ${theme.textMuted}`}>
              分享生活，创造价值，期待与您的合作。
            </p>
          </div>

          {/* 快速链接 */}
          <div>
            <h4 className={`font-semibold mb-4 ${theme.text}`}>快速导航</h4>
            <ul className="space-y-2">
              {footerLinks.navigation.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className={`${theme.textSecondary} hover:text-accent transition-colors text-sm`}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 合作方式 */}
          <div>
            <h4 className={`font-semibold mb-4 ${theme.text}`}>合作方式</h4>
            <ul className="space-y-2">
              {footerLinks.cooperation.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className={`${theme.textSecondary} hover:text-accent transition-colors text-sm`}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 社交平台 */}
          <div>
            <h4 className={`font-semibold mb-4 ${theme.text}`}>关注我的平台</h4>
            <div className="grid grid-cols-3 gap-2">
              {Object.entries(social || {}).map(([platform, url]) => {
                if (!platformIcons[platform]) return null
                return (
                  <a
                    key={platform}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`flex items-center justify-center w-10 h-10 rounded-lg transition-colors text-xl ${theme.chipBg} hover:bg-gray-700`}
                    title={platformNames[platform]}
                  >
                    {platformIcons[platform]}
                  </a>
                )
              })}
            </div>
          </div>
        </div>

        {/* 分隔线 */}
        <div className={`border-t mt-12 pt-8 ${theme.divider}`}>
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className={`text-sm ${theme.textMuted}`}>
              © {currentYear} {profile?.name || '创作者'}. All rights reserved.
            </p>
            <p className={`text-sm flex items-center gap-1 ${theme.textMuted}`}>
              Made with <Heart className="w-4 h-4 text-red-500 fill-red-500" /> for creators
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
